<template>

    <form novalidate class="md-layout" @submit.prevent="validateUser">

      <div class="md-layout-item md-elevation-0"> 

        <md-card class="md-elevation-0 m-5">

          <md-card-header class="md-layout md-alignment-center-left justify header-bg">
          Declaración Jurada de Origen de Fondos (Datos)
          </md-card-header>     

          <md-card-content>
            <p align="justify">
              Ante cualquier duda, comuníquese con su promotor.
            </p>

          </md-card-content> 
        </md-card>  

        <md-card class="md-elevation-0 m-5">
          <md-card-header class="md-layout md-alignment-center-left justify">
          <b>Ejecutante: persona que realiza físicamente la transacción monetaria</b>
          </md-card-header>     
        </md-card>          

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nombreejecutante')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Apellido(s) y Nombre(s) del Ejecutante: *
          </md-card-header>
          <md-card-content>

            <div>            
              <md-field :class="getValidationClass('nombreejecutante')">
                <md-input type="text" id="paterno" name="paterno" placeholder="Su respuesta" v-on:keypress="isLetter($event, 0)" v-model="form.nombreejecutante"  autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nombreejecutante.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nombreejecutante.alpha">Formato inválido.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>                                        

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('docIdentidadejecutante')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Tipo de Documento del Ejecutante *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.docIdentidadejecutante" value="DNI">DNI</md-checkbox>
                <md-checkbox v-model="form.docIdentidadejecutante" value="CE">Carné Extranjería</md-checkbox>
                <md-checkbox v-model="form.docIdentidadejecutante" value="PAS">Pasaporte</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('docIdentidadejecutante')">
                <span class="md-error" v-if="!$v.form.docIdentidadejecutante.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nroIdentidadejecutante')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Número de documento de identidad *
          </md-card-header>
          <md-card-content>

            <div>
              <md-field :class="getValidationClass('nroIdentidadejecutante')">
                <md-input type="text" id="nroIdentidad" name="nroIdentidad" placeholder="Su respuesta" v-model="form.nroIdentidadejecutante" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nroIdentidadejecutante.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nroIdentidadejecutante.valDoc1">Formato inválido</span>
                <span class="md-error" v-else-if="!$v.form.nroIdentidadejecutante.minLength">Formato inválido</span>  
              </md-field>

            </div>
          </md-card-content> 
        </md-card>
                          
        <md-card class="md-elevation-0 m-5">
          <md-card-header class="md-layout md-alignment-center-left justify">
          <b>Ordenante: persona que ordena realizar la suscripción</b>
          </md-card-header>     
        </md-card>          

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nombreordenante')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Apellido(s) y Nombre(s) del Ordenante: *
          </md-card-header>
          <md-card-content>

            <div>            
              <md-field :class="getValidationClass('nombreordenante')">
                <md-input type="text" id="paterno" name="paterno" placeholder="Su respuesta" v-model="form.nombreordenante" v-on:keypress="isLetter($event, 0)" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nombreordenante.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nombreordenante.alpha">Formato inválido.</span>
                
              </md-field>

            </div>
          </md-card-content> 
        </md-card>                                        

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('docIdentidadordenante')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Tipo de Documento del Ordenante *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.docIdentidadordenante" value="DNI">DNI</md-checkbox>
                <md-checkbox v-model="form.docIdentidadordenante" value="CE">Carné Extranjería</md-checkbox>
                <md-checkbox v-model="form.docIdentidadordenante" value="PAS">Pasaporte</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('docIdentidadordenante')">
                <span class="md-error" v-if="!$v.form.docIdentidadordenante.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nroIdentidadordenante')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Número de documento de identidad *
          </md-card-header>
          <md-card-content>

            <div>
              <md-field :class="getValidationClass('nroIdentidadordenante')">
                <md-input type="text" id="nroIdentidad" name="nroIdentidad" placeholder="Su respuesta" v-model="form.nroIdentidadordenante" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nroIdentidadordenante.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nroIdentidadordenante.valDoc2">Formato inválido</span>
                <span class="md-error" v-else-if="!$v.form.nroIdentidadordenante.minLength">Formato inválido</span>  
              </md-field>

            </div>
          </md-card-content> 
        </md-card>   


        <md-card class="md-elevation-0 m-5">
          <md-card-header class="md-layout md-alignment-center-left justify">
          <b>Beneficiario: a favor de quién se realiza la suscripción</b>
          </md-card-header>     
        </md-card>          

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('noombrebeneficiario')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Apellido(s) y Nombre(s) del Beneficiario: *
          </md-card-header>
          <md-card-content>

            <div>            
              <md-field :class="getValidationClass('noombrebeneficiario')">
                <md-input type="text" id="paterno" name="paterno" placeholder="Su respuesta" v-model="form.noombrebeneficiario" v-on:keypress="isLetter($event, 0)" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.noombrebeneficiario.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.noombrebeneficiario.alpha">Formato inválido.</span>
              </md-field>

            </div>
          </md-card-content> 
        </md-card>                                        

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('docIdentidadbeneficiario')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Tipo de Documento del Beneficiario *
          </md-card-header>
          <md-card-content>
                      
              <div>
                <md-checkbox v-model="form.docIdentidadbeneficiario" value="DNI">DNI</md-checkbox>
                <md-checkbox v-model="form.docIdentidadbeneficiario" value="CE">Carné Extranjería</md-checkbox>
                <md-checkbox v-model="form.docIdentidadbeneficiario" value="PAS">Pasaporte</md-checkbox>
              </div>       

              <div class="radioform" :class="getValidationClass('docIdentidadbeneficiario')">
                <span class="md-error" v-if="!$v.form.docIdentidadbeneficiario.required">Esta respuesta es obligatoria.</span>
              </div>

          </md-card-content> 
        </md-card>    

        <md-card class="md-elevation-0 m-5" :class="getValidationClass('nroIdentidadbeneficiario')">
          <md-card-header class="md-layout md-alignment-center-left justify">
            Número de documento de identidad *
          </md-card-header>
          <md-card-content>

            <div>
              <md-field :class="getValidationClass('nroIdentidadbeneficiario')">
                <md-input type="text" id="nroIdentidad" name="nroIdentidad" placeholder="Su respuesta" v-model="form.nroIdentidadbeneficiario" autocomplete="off"/>
                <span class="md-error" v-if="!$v.form.nroIdentidadbeneficiario.required">Esta respuesta es obligatoria.</span>
                <span class="md-error" v-else-if="!$v.form.nroIdentidadbeneficiario.valDoc3">Formato inválido</span>
                <span class="md-error" v-else-if="!$v.form.nroIdentidadbeneficiario.minLength">Formato inválido</span>  
              </md-field>

            </div>
          </md-card-content> 
        </md-card>                                                    

      <Botonera :form="form" :back="back" :Bottontitle="'Siguiente'"/>   

      </div>

    </form>

</template>

<style lang="scss" scoped>
  //@import "~vue-material/theme/engine";

</style>

<script>
import { validationMixin } from 'vuelidate'
import { alpha, alpha1, alpha2, alpha3, numero } from '../variables'
import {
  required,
  minLength,
} from 'vuelidate/lib/validators'

const valDoc1 = (value, vm) => {

    if(vm.docIdentidadejecutante == "DNI"){
      return numero(value)
    }else{
      return alpha3(value)
    }
    //return vm.numberPersons >= 1;
};
const valDoc2 = (value, vm) => {

    if(vm.docIdentidadordenante == "DNI"){
      return numero(value)
    }else{
      return alpha3(value)
    }
    //return vm.numberPersons >= 1;
};
const valDoc3 = (value, vm) => {

    if(vm.docIdentidadbeneficiario == "DNI"){
      return numero(value)
    }else{
      return alpha3(value)
    }
    //return vm.numberPersons >= 1;
};

export default {
  mixins: [validationMixin],
  name: 'Item18',
  data: () => ({
    form:{
    }
  }),

  mounted: function(){
    this.form = this.$store.state.item.item18
    //this.$store.dispatch("back", false);
  },
  validations(){
    var validate = {
      form: {      
        nombreejecutante: {required, alpha},
        docIdentidadejecutante: {required,},
        nroIdentidadejecutante: {required, valDoc1, minLength: minLength(3)},
        nombreordenante: {required, alpha},
        docIdentidadordenante: {required,},
        nroIdentidadordenante: {required, valDoc2, minLength: minLength(3)},
        noombrebeneficiario: {required, alpha},
        docIdentidadbeneficiario: {required,},
        nroIdentidadbeneficiario: {required, valDoc3, minLength: minLength(3)},
      }        
    }
    return validate;
  },
  methods: {
    isLetter(e, i) {
      let char = String.fromCharCode(e.keyCode); // Get the character
      let validate;
      switch (i) {
        case 0:
          validate = alpha
          break;
        case 1:
          validate = alpha1
          break;          
        case 2:
          validate = alpha2
          break;
        case 3:
          validate = alpha3
          break;                    
      }

      if(validate(char)) return true; // Match with regex 
      else e.preventDefault(); // If not match, don't add to input text
    },    
    back () {
      this.$emit('setBack', {id: this.$options.name})
      this.form = this.$store.state.item.item18
    },       
    ChangeOption(item){
      console.log(item)
    },
    validateUser () {
      this.$v.$touch()

      if (!this.$v.$invalid) {
        this.$emit('setSaveForm', {id:"18", form: this.form, index: "19"}); 
      }

    },
    getValidationClass (fieldName) {
      const field = this.$v.form[fieldName]

      if (field) {
        return {
          'md-invalid': field.$invalid && field.$dirty
        }
      }
    },
    getValidationClass2 (fieldName) {
      const field = this.$v.form[fieldName]
      const field1 = this.$v.form[fieldName+"des"]

      if (field) {

        var x = field.$invalid && field.$dirty;
        var y = field1.$invalid && field1.$dirty;

        return {
          'md-invalid': x || y
        }
      }
    },      
     
  },
  computed: {
    otros: function () {
      return true;
    },   
    isRequired:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    },
    isVisible:function(){
      if(this.$route.params.token != null){
        return false
      }
      return true
    }

  },
  components:{
    "Botonera": () => import('./Botonera.vue')
  }
}
</script>
